import { OrganisationKeys } from "@sso/constant";
import { SearchFieldKeys, TableColumn } from "@sso/types";

export const organisationTableColumns: TableColumn<OrganisationKeys>[] = [
  {
    name: "Name",
    field: OrganisationKeys.NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Products",
    field: OrganisationKeys.PRODUCTS,
    sortable: false,
  },
  {
    name: "Number of users",
    field: OrganisationKeys.USER_COUNT,
    sortable: true,
  },
  {
    name: "Created",
    field: OrganisationKeys.CREATED,
    sortable: true,
  },
  {
    name: "Last login",
    field: OrganisationKeys.LAST_LOGIN,
    sortable: true,
  },
];
